// Types pour les traverses de la double poutre
// Module séparé inspiré du module traverses principal

export interface ParametresTraversesDoublePoutre {
  active: boolean;
  motif: TypeMotifTraverseDoublePoutre;
  motifPersonnalise?: MotifPersonnaliseDoublePoutre;
  nombreRangees: number;
  materiau: TypeMateriauTraverseDoublePoutre;
  espacementVertical: number; // Distance entre les rangées
  hauteurPosition: number; // Position relative dans la hauteur de la double poutre (0-1)
  epaisseur: number; // Épaisseur des traverses en mètres
  couleur: string; // Couleur des traverses
}

export enum TypeMotifTraverseDoublePoutre {
  SIMPLE = 'simple',
  VAGUE_DOUCE = 'vague_douce',
  LOSANGE = 'losange',
  PERSONNALISE = 'personnalise'
}

export enum TypeMateriauTraverseDoublePoutre {
  FER_A_BETON = 'fer_a_beton',
  TUBE_CARRE = 'tube_carre'
}

export interface Point3DDoublePoutre {
  x: number;
  y: number;
  z: number;
}

export interface Point2DDoublePoutre {
  x: number;
  y: number;
}

export interface GeometrieTraverseDoublePoutre {
  id: string;
  points: Float32Array;
  indices: Uint16Array;
  normales: Float32Array;
  uv: Float32Array;
}

export interface RangeeTraversesDoublePoutre {
  id: string;
  hauteur: number;
  traverses: GeometrieTraverseDoublePoutre[];
  motifApplique: TypeMotifTraverseDoublePoutre;
}

export interface StructureTraversesDoublePoutre {
  id: string;
  parametres: ParametresTraversesDoublePoutre;
  rangees: RangeeTraversesDoublePoutre[];
}

export interface MotifPersonnaliseDoublePoutre {
  id: string;
  nom: string;
  courbes: CourbeBezierDoublePoutre[];
  lignes: LigneDoublePoutre[];
  dateCreation: string;
  dateModification: string;
}

export interface CourbeBezierDoublePoutre {
  id: string;
  debut: Point2DDoublePoutre;
  fin: Point2DDoublePoutre;
  controle1: Point2DDoublePoutre;
  controle2: Point2DDoublePoutre;
  couleur: string;
  epaisseur: number;
}

export interface LigneDoublePoutre {
  id: string;
  debut: Point2DDoublePoutre;
  fin: Point2DDoublePoutre;
  couleur: string;
  epaisseur: number;
}

export interface DonneesStructureDoublePoutre {
  forme: string;
  largeur: number;
  longueur: number;
  hauteur: number; // Hauteur de la double poutre elle-même
  hauteurStructurePrincipale: number; // Hauteur de la structure principale (position de base)
  nombreMontants: number;
  positionsMontants: Point3DDoublePoutre[];
  materiau: string;
  couleur: string;
  epaisseur: number;
  poutreHaute: {
    points: Point3DDoublePoutre[];
  };
  poutreBasse: {
    points: Point3DDoublePoutre[];
  };
}

export interface TraversesDoublePoutreState {
  parametres: ParametresTraversesDoublePoutre;
  structure?: StructureTraversesDoublePoutre;
  isGenerating: boolean;
  error?: string;
  canvasActif: boolean;
}

// Paramètres par défaut
export const PARAMETRES_DEFAUT_TRAVERSES_DOUBLE_POUTRE: ParametresTraversesDoublePoutre = {
  active: false,
  motif: TypeMotifTraverseDoublePoutre.SIMPLE,
  motifPersonnalise: undefined,
  nombreRangees: 1,
  materiau: TypeMateriauTraverseDoublePoutre.FER_A_BETON,
  espacementVertical: 0.1, // 10cm entre les rangées
  hauteurPosition: 0.5, // Au milieu de la hauteur de la double poutre
  epaisseur: 0.02, // 2cm d'épaisseur
  couleur: '#8B4513' // Couleur bois par défaut
};

// Contraintes de validation
export const CONTRAINTES_TRAVERSES_DOUBLE_POUTRE = {
  nombreRangees: {
    min: 1,
    max: 3, // Maximum 3 rangées pour la double poutre
    step: 1
  },
  espacementVertical: {
    min: 0.05, // 5cm minimum
    max: 0.3, // 30cm maximum
    step: 0.01
  },
  hauteurPosition: {
    min: 0.1, // 10% de la hauteur
    max: 0.9, // 90% de la hauteur
    step: 0.05
  },
  epaisseur: {
    min: 0.01, // 1cm minimum
    max: 0.05, // 5cm maximum
    step: 0.005
  }
};